import React, { memo, useCallback } from 'react'
import { List } from '@fluentui/react/lib/List'
import { HeaderUsersListCell } from './HeaderUsersListCell'
import { UsersListCell } from './UsersListCell'
import { USER_OPTION_TYPE } from '../../../helpers/usersOptionsHelpers'

export const UsersList = memo(
  ({ usersOptions, project, onSelectUser, editing, fromProject = false, onShowError, ...rest }) => {
    const readOnly = !onSelectUser

    const createOnSelect = useCallback(
      user => () => {
        onSelectUser(user)
      },
      [onSelectUser]
    )

    const onRenderCell = useCallback(
      option => {
        const { itemType, key, text, user, infoLink } = option
        if (itemType === USER_OPTION_TYPE.HEADER) {
          return <HeaderUsersListCell key={key} text={text} infoLink={infoLink} />
        } else {
          const userListCellProps = {
            user,
            editing,
            readOnly,
            fromProject,
            project,
            onShowError,
          }
          if (!readOnly) {
            userListCellProps.onClick = createOnSelect(user)
          }
          return <UsersListCell {...userListCellProps} />
        }
      },
      [editing, readOnly, fromProject, project, onShowError, createOnSelect]
    )

    return <List items={usersOptions} onRenderCell={onRenderCell} {...rest} />
  }
)
